import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { IReleaseNotes } from '../shared/interfaces/release-notes';



@Injectable({
  providedIn: 'root'
})
export class ReleaseInfoService {
  
  baseUrl: string = environment.API_URL;
      serviceBase = this.baseUrl + '/api/releaseNotes';
  queryString: string;

  constructor(private http: HttpClient) { }

  addUpdateReleaseNote(releaseNote: IReleaseNotes) {
    return this.http.post<IReleaseNotes>(this.serviceBase + '/addUpdateReleaseNote', releaseNote);
  }

  getAllReleaseNotes(): Observable<IReleaseNotes[]> {
    this.queryString = '/getAllReleaseNotes';
    return this.http.get<IReleaseNotes[]>(this.serviceBase + this.queryString);
  }

  deleteReleaseNote(releaseNoteId: any) {
    this.queryString = '/deleteReleaseNote?releaseNoteId=' + releaseNoteId;
    return this.http.post<IReleaseNotes[]>(this.serviceBase + this.queryString, null);
  }

}
